module.exports = __webpack_public_path__ + "static/media/check_availability.46ac2e50.png";